import { useRef } from 'react';
import styled from 'styled-components';
import type { MediaImageProps } from '@elfsight/widget-media';
import { MediaImage as MediaImageComponent } from '@elfsight/widget-media';
import { getColorWithAlpha } from '@elfsight/widget-utils';
import { usePostSettings } from '../../utils';

function _MediaImage({
  src,
  ratio,
  borderRadius,
  backgroundColor,
  alt = '',
  ...forwardingProps
}: MediaImageProps) {
  const { textColor } = usePostSettings();
  const ref = useRef<HTMLDivElement>(null);

  return (
    <MediaImageComponent
      {...forwardingProps}
      ref={ref}
      withSkeleton
      skeletonBorderRadius={0}
      alt={alt}
      src={src}
      ratio={ratio}
      borderRadius={borderRadius}
      backgroundColor={backgroundColor}
      skeletonColor={getColorWithAlpha(textColor, 0.2)}
    />
  );
}

export const MediaImage = styled(_MediaImage)``;
